// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"f1e38e17","60":"69dd1d4d","198":"15e96d2f","557":"9643f95f","588":"69dd1d4d"}[chunkId] + ".css";
};